import React, { useState, useEffect } from 'react'
import ClinicInfo from './ClinicInfo'
import * as d3 from 'd3'

const Circle = ({ coordinates, projection, info, red, onMouseDown }) => {
    if (!coordinates || !Array.isArray(coordinates) || coordinates.length !== 2)
        return null
    const [hovered, setHovered] = useState(false)
    const [cx, cy] = projection([coordinates[1], coordinates[0]])
    const [opacity, setOpacity] = useState(0)
    const scaledOuterCircleSize = hovered ? 34.1 : 31 // +10% scale on hover
    const scaledInnerCircleSize = hovered ? 20.9 : 19 // +10% scale on hover
    const circleColor = red ? '#FF0000' : '#0093DD'

    const handleMouseEnter = (event) => {
        setHovered(true)
        // Bring the hovered circle to the front
        d3.select(event.target.parentNode).raise()
    }

    useEffect(() => {
        // smooth transition
        if (hovered) {
            let temp = 0
            const interval = setInterval(() => {
                temp += 0.1
                setOpacity(temp)
                if (temp >= 1) {
                    clearInterval(interval)
                }
            }, 20)
        } else {
            let temp = 1
            const interval = setInterval(() => {
                temp -= 0.1
                if (temp < 0) temp = 0
                setOpacity(temp)
                if (temp <= 0) {
                    clearInterval(interval)
                }
            }, 20)
        }
    }, [hovered])

    return (
        <>
            <g
                onMouseEnter={handleMouseEnter}
                onMouseLeave={() => setHovered(false)}
                style={{ cursor: 'pointer' }}
                onMouseDown={onMouseDown} // Add mouse down event to the group
            >
                <circle
                    cx={cx}
                    cy={cy}
                    r={scaledOuterCircleSize / 2}
                    fill={circleColor}
                    opacity='0.5'
                    style={{ transition: 'all 0.3s ease' }}
                />
                <circle
                    cx={cx}
                    cy={cy}
                    r={scaledInnerCircleSize / 2}
                    fill={circleColor}
                    style={{ transition: 'all 0.3s ease' }}
                />
                {info && opacity && opacity > 0 && hovered && (
                    <ClinicInfo
                        info={info}
                        cx={cx}
                        cy={cy}
                        scaledOuterCircleSize={scaledInnerCircleSize}
                        opacity={opacity}
                    />
                )}
            </g>
        </>
    )
}

export default Circle
